// Service for the Attendance Dashboard "Mi equipo" — "Situación de asistencia" section,
// "Atraso" card (ASIS-5405 / REXASIS-004).
// GET /attendance/my-team/today/tardiness-summary?companyIds=1,2&employeeIds=10,15 —
// both query params are optional CSV lists; omitted/[] means "Todos" (no filter),
// scoped to the Empresa/Colaborador filters of the "Mi equipo" dashboard.

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';

import type {
  LC_GetTodayTardinessSummaryOut,
  GetMyTeamTardinessSummaryParams,
  MyTeamTardinessSummary,
} from '../types/myTeamTardinessSummary.types';
import { mapMyTeamTardinessSummary } from '../mappers/myTeamTardinessSummary.mapper';


export class MyTeamTardinessSummaryService {
  async getSummary(
    params?: GetMyTeamTardinessSummaryParams,
    signal?: AbortSignal,
  ): Promise<ApiResponse<MyTeamTardinessSummary>> {
    const query = buildQueryString({
      companyIds: params?.companyIds?.map(String),
      employeeIds: params?.employeeIds?.map(String),
    });
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE_MY_TEAM_TODAY_TARDINESS_SUMMARY}${query}`;
    const response = await apiClient.get<LC_GetTodayTardinessSummaryOut>(endpoint, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapMyTeamTardinessSummary(response.data) };
  }
}

export const myTeamTardinessSummaryService = new MyTeamTardinessSummaryService();
